import { getFrontendToolbar } from "../utils/dom.js";
import DockableWindow from "./dockable-window.js";
import { resolveAvatarSrc } from "../../avatars/index.js";
import { getPeer } from "./players.js";

const SVG_ATTRS = `viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"`;

const ICONS = {
    chat: `<svg ${SVG_ATTRS}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
    send: `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"/></svg>`,
};

export default class Chat {
    constructor(socket, username, color, avatar, uid) {
        this.socket = socket;
        this.username = username;
        this.color = color;
        this.avatar = avatar;
        this.uid = uid;

        this.launcher = null;
        this.launcherButton = null;
        this.badge = null;
        this.dock = null;

        this.lastSender = null;
        this.notificationNumber = 0;

        this.customCss = `
        .tag{
            position: absolute;
            transform:translate(-110px,0px);
        }

        .tagName {
            color:white;
            padding: 4px;
            border-radius: 20px;
        }

        .usernameTag {
            position: absolute;
            top:90px;
            font-size: 30px;
            font-family: helvetica;
            font-weight: bold;
            text-align: center;
            width: 100px;
            opacity: 0;
            transition: .2s;
            display: flex;
            align-self: center;
            align-items: center;
            justify-content: center;
            justify-items:center;
        }

        .tag:hover .usernameTag{
            opacity: 1;
        }

        .tag.turnOn {
            animation-name: indicateOn;
            animation-duration: .25s;
            animation-fill-mode:forwards;

        }

        .tag.turnOff{
            animation-name: indicateOff;
            animation-duration: .25s;
            animation-fill-mode:forwards;
        }

        @keyframes indicateOn {
            from {
                transform:translate(-170px,0px);
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        @keyframes indicateOff {
            from {
                opacity: 1;

            }
            to {
                transform:translate(-170px,0px);
                opacity: 0;
            }
        }

        .blocRect{
            outline-style: solid;
            outline-width: 0px;
            border-radius: 20px;
        }

        .blocRect.turnOn {
            animation-name: outlineSelect;
            animation-duration: .25s;
            animation-fill-mode:forwards;
        }

        .blocRect.turnedOn {
            outline-offset: 0px;
        }

        .blocRect path {
            transition: stroke-width: .3s;
        }

        :root {
            --stroke-color: #58c198;
        }

        .turnedOn path:not([data-shapes="round"] > path) {
            stroke: var(--stroke-color);
            stroke-width: 2.5px;
        }

        .blocRect.turnOff{
            animation-name: outlineUnselect;
            animation-duration: .25s;
            animation-fill-mode:forwards;
        }

        .blocRect.turnedOff{
            outline:none;
        }

        .blockly-name-tag {
            opacity: 1;
            transition: opacity .3s;
        }

        .turnedOff > .blockly-name-tag {
            opacity: 0;
        }

        @keyframes outlineSelect {
            from {
                outline-offset: 20px;
                outline-color: rgba(0,0,0,0);
            }
            to {
                outline-offset: 0px;
            }
        }
        @keyframes outlineUnselect {
            to {
                outline-offset: 20px;
                outline-color: rgba(0,0,0,0);
            }
            from {
                outline-offset: 0px;
            }
        }

        .ls-chat-launcher {
            order: 1;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }

        .ls-chat-launcher-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            padding: 0;
            border: none;
            border-radius: 999px;
            background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
            color: #fff;
            box-shadow: 0 2px 8px rgba(133, 92, 214, 0.35);
            cursor: pointer;
            transition: transform 0.15s ease, filter 0.15s ease, background 0.15s ease, color 0.15s ease;
        }

        .ls-chat-launcher-btn svg {
            width: 18px;
            height: 18px;
        }

        .ls-chat-launcher-btn:hover {
            filter: brightness(1.05);
            transform: scale(1.06);
        }

        .ls-chat-launcher-btn:active {
            transform: scale(1);
        }

        .ls-chat-launcher-btn.is-open {
            background: #fff;
            color: #855cd6;
            border: 1px solid rgba(133, 92, 214, 0.25);
        }

        .ls-chat-badge {
            position: absolute;
            top: -4px;
            right: -4px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: 999px;
            background: #ff6680;
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            line-height: 16px;
            text-align: center;
            box-shadow: 0 0 0 2px #fff;
            pointer-events: none;
        }

        .ls-chat-badge[hidden] {
            display: none !important;
        }

        .emojione{
            height: 20px;
            margin-bottom: -3px;
        }

        ls-chat-msgs{
            display: flex;
            flex-shrink:1;
            flex-direction: column;
            padding:10px;
            overflow-y: auto;
            flex-grow:1;

            font-family: Tahoma, sans-serif;
            font-size: 14px;
            line-height: 20px;
            color: #2c2c3a;
            gap:3px;
            align-items: flex-start;
        }
        ls-chat-msgs::-webkit-scrollbar { width: 6px; }
        ls-chat-msgs::-webkit-scrollbar-thumb { background: rgba(133, 92, 214, 0.25); border-radius: 999px; }

        .mymsg{
            align-self: flex-end;
        }
        ls-msg-space{height:8px}
        ls-msg:not(.mymsg){
            border-top-left-radius: 0;
        }
        ls-msg.mymsg{
            border-top-right-radius: 0;
            background-color: #f3eefc !important;
        }
        ls-msg{
            max-height: 220px;
            overflow-y: auto;
            flex-shrink: 0;
            color: #2c2c3a;
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 10px;
            padding: 6px 10px;
            max-width: 80%;
            margin-left: 15px;
            font-size: 14px;
            background-color: #fafafd;
            overflow-wrap: anywhere;
        }
        ls-msg-sender-name{
            font-style:italic;
            font-size: 12px;
            color: #7a6f99;
        }
        ls-msg-sender:first-of-type{
            margin-top: 1px;
        }
        ls-msg-sender{
            align-items: center;
            margin-top: 5px;
            display: flex;
            flex-direction: row;
            gap:5px;
        }
        ls-msg-sender-img{
            background-size: contain;
            background-repeat: no-repeat;
            width:22px;
            height:22px;
            border-radius: 10px;
        }

        ls-chat-send-button{
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            display: flex;
            user-select: none;
            width: 40px;
            height: 100%;
            min-height: 40px;
            background-color: #855cd6;
            color:white;
            text-align: center;
            border-left: 1px solid rgba(0,0,0,0.06);
            border-radius: 0 8px 8px 0;
            cursor: pointer;
            transition: background 0.15s ease;
        }
        ls-chat-send-button:hover{
            background-color: #6b4bb5;
        }
        ls-chat-send{
            max-height: 150px;
            min-height: 40px;
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 8px;
            border: 1px solid rgba(0,0,0,0.08);
            margin: 10px;
            margin-top: 0;
            box-shadow: 0px -2px 5px 0px rgba(0,0,0,0.06);
            overflow: clip;
        }

        ls-chat-input{
            flex-grow: 1;
            max-height:150px;
            overflow-y: auto;
            text-overflow: clip;
            overflow-wrap: anywhere;

            font-size:14px;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
            padding:10px;
            background-color: transparent;
        }
        ls-chat-input:empty::before {
            content: "Escribe un mensaje…";
            color: #a89bc7;
        }
        ls-chat-input:focus{
            outline: none;
        }`;

        this.ChatBodyHTML = `
        <ls-chat-msgs>
            <ls-msg-space></ls-msg-space>
        </ls-chat-msgs>
        <ls-chat-send>
            <ls-chat-input contenteditable="true"></ls-chat-input>
            <ls-chat-send-button>${ICONS.send}</ls-chat-send-button>
        </ls-chat-send>`;

        this.injectCSS();
        this.mountLauncher();
        this.mountWindow();
    }

    injectCSS() {
        try {
            let styleInj = document.createElement("style");
            styleInj.innerHTML = this.customCss;
            document.head.appendChild(styleInj);
        } catch (e) {
            console.error(e);
        }
    }

    mountLauncher() {
        const toolbar = getFrontendToolbar();
        if (!toolbar) {
            console.error("Chat: editor toolbar not found");
            return;
        }

        this.launcher = document.createElement("div");
        this.launcher.className = "ls-chat-launcher";
        this.launcher.innerHTML = `
            <button type="button" class="ls-chat-launcher-btn" title="Chat">
                ${ICONS.chat}
                <span class="ls-chat-badge" hidden></span>
            </button>
        `;

        this.launcherButton = this.launcher.querySelector(
            ".ls-chat-launcher-btn",
        );
        this.badge = this.launcher.querySelector(".ls-chat-badge");
        this.launcherButton.addEventListener("click", () => this.toggle());

        toolbar.appendChild(this.launcher);
    }

    mountWindow() {
        this.dock = new DockableWindow({
            id: "ls-chat",
            title: "Chat",
            width: 320,
            height: 440,
            minWidth: 260,
            minHeight: 280,
            maxWidth: 600,
            maxHeight: "80vh",
            anchoredFill: true,
            onClose: () => this.launcherButton?.classList.remove("is-open"),
        });
        this.dock.bodyEl.innerHTML = this.ChatBodyHTML;

        this.dock.bodyEl
            .querySelector("ls-chat-send-button")
            .addEventListener("click", () => this.postMessageBubble());
        this.dock.bodyEl
            .querySelector("ls-chat-input")
            .addEventListener("keydown", (e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    this.postMessageBubble();
                }
            });
    }

    toggle() {
        if (this.isChatOpen()) this.close();
        else this.open();
    }

    open() {
        this.dock.positionNear(this.launcherButton);
        this.dock.open();
        this.launcherButton.classList.add("is-open");
        this.onChatNotification(0);
    }

    close() {
        this.dock.close();
        this.launcherButton.classList.remove("is-open");
    }

    postMessageBubble() {
        const inputElement = this.dock.bodyEl.querySelector("ls-chat-input");
        let message = inputElement.innerText;
        message = message.trim();

        if (message == "") return;
        const messageObject = {
            sender: this.username,
            message: message,
            color: this.color,
            uid: this.uid,
        };

        this.addMessage({ ...messageObject, avatar: this.avatar }, this.color);
        this.socket.emit("chat", messageObject);

        inputElement.innerText = "";
    }

    addMessage(message, color) {
        const msgsElement = this.dock.bodyEl.querySelector("ls-chat-msgs");
        const msgElement = document.createElement("ls-msg");

        if (this.lastSender != message.sender) {
            let nameElement = document.createElement("ls-msg-sender");
            nameElement.innerHTML = `<ls-msg-sender-img></ls-msg-sender-img>
            <ls-msg-sender-name>${message.sender}</ls-msg-sender-name>`;
            nameElement.style.color = color;
            nameElement.querySelector("ls-msg-sender-img").style.backgroundImage =
                `url("${resolveAvatarSrc(message.avatar ?? getPeer(message.uid)?.avatar)}")`;

            this.lastSender = message.sender;
            if (message.sender == this.username) {
                nameElement.classList.add("mymsg");
            }
            msgsElement.appendChild(nameElement);
        }

        msgElement.innerHTML = message.message;
        if (message.sender == this.username) msgElement.classList.add("mymsg");
        msgsElement.appendChild(msgElement);
        msgsElement.scrollTop = msgsElement.scrollHeight;

        if (!this.isChatOpen())
            this.onChatNotification(this.notificationNumber + 1);
    }

    isChatOpen() {
        return this.dock.isOpen();
    }

    onChatNotification(number) {
        this.notificationNumber = number;
        this.badge.textContent = number > 99 ? "99+" : number;
        this.badge.hidden = number === 0;
    }
}
